export default {
  computed : {
    isRequireLandscapeProtect(){
      return this.$store.state.layouts.isRequireLandscapeProtect;
    }
  },
  
  methods : {
    isAccessedMobileIOS(){
      const isIphone = navigator.userAgent.indexOf('iPhone') != -1;
      const isIpod   = navigator.userAgent.indexOf('iPod') != -1;

      if(isIphone){
        return true;
      }

      if(isIpod){
        return true;
      }

      return false;
    },

    isAccessedMobileAndroid(){
      const isAndroid = navigator.userAgent.indexOf('Android') != -1;

      if(isAndroid){
        return true;
      }

      return false;
    },

    isAccessedMobileDevice(){
      if(this.isAccessedMobileIOS() || this.isAccessedMobileAndroid()){
        return true;
      }else{
        return false;
      }
    },

    isRequireLandScapeProtectWindowSize(){
      // widthとheightを配列に入れます。その後小さい方のサイズを取得します。
      // 小さい方のサイズをデバイスの横幅として使用します。
      // (最初から横持ちでアクセスされるとwidthとheightが逆になるため。)
      const windowSizes = [window.innerWidth, window.innerHeight];

      // 昇順にします。Indexで0が小さい方として取得できる
      windowSizes.sort();

      if((windowSizes[0] <= 768)){
        return true;
      }else{
        return false;
      }
    },

    isLandscapeOrientation(){
      const screenOrientation = screen.msOrientation || screen.mozOrientation || (screen.orientation || {}).type;

      if(screenOrientation === undefined){
        // for iOS
        if( (window.orientation === 90) || (window.orientation === -90) ){
          return true;
        }else{
          return false;
        }
      }else{
        if( (screenOrientation === 'landscape-primary') || (screenOrientation === 'landscape-secondary') ){
          return true;
        }else{
          return false;
        }
      }
    },

    checkDeviceOrientation(){
      // landscapeの場合は特別素材を表示します。
      if( this.isAccessedMobileDevice() && this.isRequireLandScapeProtectWindowSize() && this.isLandscapeOrientation() ){
        this.$store.dispatch('layouts/updateLandscapeProtect', true, {root:true});
      }else{
        this.$store.dispatch('layouts/updateLandscapeProtect', false, {root:true});
      }
    },
    
    initializeOrientation(){
      this.checkDeviceOrientation();

      window.addEventListener('orientationchange', () => {
          this.checkDeviceOrientation();
      });
    }
  },
  mounted(){
    this.initializeOrientation();
  }
};
